import React from "react";
import copImg from "../../assets/images/svg/blockedCop.svg";
import noAccsessSetUer from "../../assets/images/svg/noAccsessSetUer.svg";
import Header from "../../components/Header/Header";

const NoAccess = () => {
  return (
    <>
      <Header type="settings" />
      <div className="outside_main_no_access">
        <div className="no_access_outside">
          <img className="user_img" src={noAccsessSetUer} alt="user" />
          <h2>Good morning Praveen</h2>
          <img src={copImg} alt="officer" />
          <h3>You don’t have account access</h3>
          <p>
            Typically, access is controlled by your Family Head. To get access,
            request your Family Head to enable access for you on the app.
          </p>
        </div>
      </div>
    </>
  );
};

export default NoAccess;
